import React, { useEffect, useState } from "react";
// import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

import { Modal, Spin } from "antd";

import { Viewer } from "@toast-ui/react-editor";

import longlifeApi from "../../../apis/Longlife.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ApiService from "../../../utils/ApiService";

import CommunityFavorite from "./CommunityFavorite";

const api = new ApiService();

const CommunityLonglifeModal = ({
	modalShow,
	setModalShow,
	setSelectCommunity,
	detail,
	scrollToComment,
	symptomList,
}) => {
	const dispatch = useDispatch();
	// const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [item, setItem] = useState({});

	const handleLoad = () => {
		const modal = document.getElementsByClassName("ant-modal-content");
		const commentScroll = document.getElementById(
			"community-comment-favorite-id"
		);
		if (scrollToComment) {
			if (modal) {
				// console.log(modal[0].scrollTop);
				if (!modal[0].scrollTop) {
					modal[0]?.scrollTo({
						// top: 0,
						top: commentScroll?.offsetTop,
						// behavior: 'smooth'
					});
				}
			}
		}
	};

	useEffect(() => {
		if (detail?.id && !item?.id) {
			getCommunity();
		}
		return () => {
			setIsLoading(false);
		};
	}, [detail, item, cUser]);

	const getCommunity = async () => {
		setIsLoading(true);
		try {
			let res;
			if (detail?.category === "mission") {
				const param = {
					offset: 0,
					pageSize: 5,
					pageType: switchCategoryForEng(detail?.content_type),
					missionId: detail?.id,
					userId: cUser?.id ? cUser.id : 0,
					apiType: "admin",
				};
				res = await longlifeApi.getContent(param);
			} else {
				const param = {
					id: detail?.id,
				};
				const contentRes = await api.readContentOneForTogetherAdmin(param);
				res = contentRes.data;
			}
			if (res.code === 200) {
				setItem(res.result);
			}
		} catch (e) {
			console.log(e);
		}
		setIsLoading(false);
	};

	const switchCategoryForEng = (categoryId) => {
		switch (categoryId) {
			case 0:
				return "mission";
			case 1:
				return "community";
			case 2:
			case 3:
				return "feed";
			default:
				return "";
		}
	};

	const switchCategory = (categoryId) => {
		switch (categoryId) {
			case "mission":
				return "클래스";
			case "compare":
			case "nutrition_encyclopedia":
			case "age":
			case "symptom":
			case "trend":
			case "selection":
			case "brand":
			case "etc":
				return "건강 매거진";
			case "cooperate":
				return "공동구매";
			case "recommend_nutrients":
				return "문의글";
			case "event":
				return "이벤트";
			// case "compare":
			// 	return "비교하기";
			// case "nutrition_encyclopedia":
			// 	return "영양백과";
			// case "age":
			// 	return "연령별";
			// case "symptom":
			// 	return "증상별";
			// case "trend":
			// 	return "트렌드";
			// case "selection":
			// 	return "선택기준";
			// case "brand":
			// 	return "브랜드";
			// case "etc":
			// 	return "기타";
			// case 0:
			// 	return "미션";
			// case 1:
			// 	return "소통글";
			// case 2:
			// 	return "피드";
			// case 3:
			// 	return "상세피드";
			default:
				return "";
		}
	};

	const switchAgeCategory = (subCategory) => {
		switch (subCategory) {
			case 0:
			case "0":
				return "0~2세";
			case 1:
			case "1":
				return "2~13세";
			case 2:
			case "2":
				return "0~13세";
			case 3:
			case "3":
				return "청소년";
			case 4:
			case "4":
				return "청소년부터 성인까지";
			case 5:
			case "5":
				return "성인";
			case 6:
			case "6":
				return "전 연령";
			case 9:
			case "9":
				return "50세 이상";
			case 99:
			case "99":
				return "기타";
		}
	};

	// const switchSymptomCategory = (subCategory) => {
	// 	const findIdx = symptomList.findIndex(
	// 		(symptom) => symptom.effect_id === subCategory
	// 	);
	// 	if (findIdx > -1) {
	// 		return symptomList[findIdx].effect_name;
	// 	} else {
	// 		return "";
	// 	}
	// };

	return (
		<Modal
			// title="인기검색어 예시"
			wrapClassName="home-community-modal"
			open={modalShow}
			centered={true}
			maskClosable={true}
			closable={false}
			onCancel={() => {
				setModalShow(false);
				setSelectCommunity(null);
			}}
			width="60%"
			footer={null}
		>
			{isLoading && (
				<Spin
					style={{
						margin: "auto",
						width: "100%",
						paddingTop: "2em",
						position: "absolute",
						left: 0,
						right: 0,
					}}
				/>
			)}
			<img
				src={`/assets/images/channel/white-close.png`}
				alt={`white-close`}
				className={`photo-img`}
				style={{
					position: "absolute",
					top: 0,
					right: "-2.5em",
					width: "2.2em",
					height: "2.2em",
					cursor: "pointer",
				}}
				onClick={() => {
					setModalShow(false);
				}}
			/>
			<div
				className={`home-community-each modal-community community-each-page`}
				onLoad={handleLoad}
			>
				<div className={`home-community-content`}>
					<div className={`community-title-div`}>
						<p
							className={`community-tag`}
							style={{
								backgroundColor: `${
									item?.background_color ? item.background_color : "#868e96"
								}`,
							}}
						>
							{switchCategory(item?.category)}
							{/*{item?.category &&*/}
							{/*	item?.sub_category &&*/}
							{/*	(item?.category === "age"*/}
							{/*		? `-${switchAgeCategory(item?.sub_category)}`*/}
							{/*		: `-${switchSymptomCategory(item?.sub_category)}`)}*/}
							{/*{switchCategory(item?.content_type) &&*/}
							{/*	`[${switchCategory(item?.content_type)}]-`}*/}
							{/*{item?.category_name}*/}
						</p>
						<p className={`community-title`}>
							{item?.category === "mission" ? item?.title : item?.head_copy}
						</p>
						<p
							className={`community-sub-title`}
							style={{ whiteSpace: "normal" }}
						>
							{item?.category === "mission" ? item?.sub_title : item?.sub_copy}
						</p>
						{/*{item?.content_type === 0 && (*/}
						{/*	<p className={`community-sub-title`}>{item?.sub_title}</p>*/}
						{/*)}*/}
					</div>
					<CommunityFavorite
						item={item}
						type={"header"}
						serviceType={"healthMagazine"}
					/>
					{/*<div className={`community-footer-div`}>*/}
					{/*    <p>*/}
					{/*        좋아요 {item?.like_num ?? 0}*/}
					{/*    </p>*/}
					{/*    <p>·</p>*/}
					{/*    <p>*/}
					{/*        댓글 {item?.comment_num ?? 0}*/}
					{/*    </p>*/}
					{/*    <p>·</p>*/}
					{/*    <p>*/}
					{/*        조회 {Math.ceil(item?.view_num * (5 + (item?.id % 10 / 10)))}*/}
					{/*        /!*{item?.view_num ?? 0}*!/*/}
					{/*    </p>*/}
					{/*    <p>·</p>*/}
					{/*    <p>*/}
					{/*        {moment(item?.created_at).format("YYYY.MM.DD")}*/}
					{/*    </p>*/}
					{/*</div>*/}
					<Viewer
						key={`longlife-content-${item?.id}`}
						initialValue={item?.content}
					/>
					{/*<div className={`community-body-div`}>*/}
					{/*	<p>{item?.body}</p>*/}
					{/*</div>*/}
				</div>
				{/*<div className={`home-community-image`}>*/}
				{/*	{!!item?.communityImageList?.length && (*/}
				{/*		<Image.PreviewGroup>*/}
				{/*			{item?.communityImageList?.map((img, index) => (*/}
				{/*				<Image*/}
				{/*					preview={{*/}
				{/*						// visible: false,*/}
				{/*						mask: <></>,*/}
				{/*						// current: index,*/}
				{/*						// countRender: (c,t) => console.log(c, t)*/}
				{/*					}}*/}
				{/*					key={`list-img-${index}`}*/}
				{/*					src={`${process.env.REACT_APP_S3_HOST}/image/together/community/${reduxChannel?.user_id}/${img?.title}.${img?.img_type}`}*/}
				{/*					onError={({ currentTarget }) => {*/}
				{/*						currentTarget.onerror = null; // prevents looping*/}
				{/*						// currentTarget.style.display = "none";*/}
				{/*						currentTarget.src = `/assets/images/no-product.png`;*/}
				{/*					}}*/}
				{/*					alt={`게시판 이미지`}*/}
				{/*					style={{*/}
				{/*						height: "auto",*/}
				{/*						width: "100%",*/}
				{/*					}}*/}
				{/*					// onClick={() => setVisible(true)}*/}
				{/*				/>*/}
				{/*			))}*/}
				{/*		</Image.PreviewGroup>*/}
				{/*	)}*/}
				{/*</div>*/}

				<div
					className={`product-body`}
					style={{
						margin: "0",
						gap: "1em",
					}}
					id={`community-comment-favorite-id`}
					// onLoad={handleLoad}
				>
					<CommunityFavorite item={item} serviceType={"healthMagazine"} />
					{/*<ChannelCommentComponent*/}
					{/*	detail={item}*/}
					{/*	type={"community"}*/}
					{/*	getCommunity={getCommunity}*/}
					{/*	getCommunityList={getCommunityList}*/}
					{/*	whereShow={whereShow}*/}
					{/*/>*/}
				</div>
			</div>
		</Modal>
	);
};
export default CommunityLonglifeModal;
